import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'pilates-reformer-pret-fin-offre';
const JOUR_EN_MS = 24 * 60 * 60 * 1000;
interface TempsRestant {
  heures: number;
  minutes: number;
  secondes: number;
}
export function AnnouncementBar() {
  const [temps, setTemps] = useState<TempsRestant>({
    heures: 24,
    minutes: 0,
    secondes: 0
  });
  useEffect(() => {
    const enregistree = Number(window.localStorage.getItem(STORAGE_KEY));
    let echeance = Number.isFinite(enregistree) && enregistree > Date.now() ? enregistree : Date.now() + JOUR_EN_MS;
    window.localStorage.setItem(STORAGE_KEY, String(echeance));
    const actualiser = () => {
      const maintenant = Date.now();
      if (echeance <= maintenant) {
        echeance = maintenant + JOUR_EN_MS;
        window.localStorage.setItem(STORAGE_KEY, String(echeance));
      }
      const secondesTotales = Math.max(0, Math.ceil((echeance - maintenant) / 1000));
      setTemps({
        heures: Math.floor(secondesTotales / 3600),
        minutes: Math.floor(secondesTotales % 3600 / 60),
        secondes: secondesTotales % 60
      });
    };
    actualiser();
    const intervalle = window.setInterval(actualiser, 1000);
    return () => window.clearInterval(intervalle);
  }, []);
  return <aside className="sticky top-0 z-50 flex h-8 w-full items-center justify-center bg-brand-slate px-2 text-white shadow-sm" data-id="element-17" data-mp="3shb1dzzyko0w">
      <div className="flex items-center gap-2 sm:gap-3" data-id="element-18" data-mp="oyrivp730wja">
        <p className="whitespace-nowrap text-[9px] font-extrabold tracking-wide sm:text-[10px]" data-id="element-19" data-mp="oz9qtj33wz71">
          <span className="hidden sm:inline" data-id="element-20" data-mp="txb8q0osqsgx">
            🔥 OFFRE DE LANCEMENT — PRIX D&apos;ACCÈS DISPONIBLE CETTE SEMAINE ·{' '}
          </span>
          SE TERMINE DANS :
        </p>
        <div className="flex items-center gap-1 font-mono" aria-label={`Il reste ${temps.heures} heures, ${temps.minutes} minutes et ${temps.secondes} secondes`} data-id="element-21" data-mp="k6qcul0ic21p">
          <UniteMinuteur valeur={temps.heures} libelle="H" data-id="element-22" data-mp="1cpdqxgh36gta" />
          <span className="text-xs font-bold" data-id="element-23" data-mp="1mkaustdbry2o">:</span>
          <UniteMinuteur valeur={temps.minutes} libelle="MIN" data-id="element-24" data-mp="1mjst3h7w8rnd" />
          <span className="text-xs font-bold" data-id="element-25" data-mp="1hkq0wxd0ifwt">:</span>
          <UniteMinuteur valeur={temps.secondes} libelle="SEC" data-id="element-26" data-mp="1hj52gwnkucto" />
        </div>
      </div>
    </aside>;
}
function UniteMinuteur({
  valeur,
  libelle
}: {
  valeur: number;
  libelle: string;
}) {
  return <span className="whitespace-nowrap text-[11px] font-extrabold sm:text-xs" data-id="element-27" data-mp="18mmapnr30uyo">
      {String(valeur).padStart(2, '0')}
      <span className="ml-0.5 text-[8px] font-bold text-white/70" data-id="element-28" data-mp="yuqfckgdriy5">{libelle}</span>
    </span>;
}